// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jrqmlzigwnzcxlcdvkuo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpycW1semlnd256Y3hsY2R2a3VvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4MjkzOTYsImV4cCI6MjA2OTQwNTM5Nn0.xGAsLzE5yux9iwjEReKm3_8dcBNzcgH5NN51BQFfzcc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});